import Layers from "slotworks/graphics/layers/layers";
import AbstractRadioControl from "slotworks/smart-ui/controls/abstract/abstract-radio-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";
import betModel from "slotworks/model/bets/bet-model";
import BetModel from "slotworks/model/bets/bet-model";

export default class TotalStakeRadioControl extends AbstractRadioControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.radioGroup.formatFunction = formatMoneyAsCurrency;
        this.setEnabled(true);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        this.updateValues(options.getTotalStakeValues(), options.getTotalStake());

        if (BetModel.freeBet) {
            this.radioGroup.setEnabled(false);
        } else {
            this.radioGroup.setEnabled(this.enabled);
        }
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.creditSizes = this.options.creditSizes.clone();
        options.selectedLines = this.options.selectedLines;
        options.creditsPerLine = this.options.creditsPerLine.clone();
        options.fixedBetCost = this.options.fixedBetCost;

        options.setTotalStake(value);

        this.onChange.dispatch(options);
    }
    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        // Never enable stepper during free bets
        if (betModel.freeBet) {
            this.radioGroup.setEnabled(false);
        }
    }
}
